import { Link } from "react-router-dom";
import { Paintbrush, BookOpen } from "lucide-react";

export default function Header() {
  return (
    <header className="absolute top-0 left-0 right-0 z-50">
      <div className="container mx-auto max-w-6xl px-6 md:px-12 lg:px-24 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-[#b91c1c] rounded-lg flex items-center justify-center shadow-md">
              <Paintbrush className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold text-slate-900">fasadmalning.se</span>
          </Link>
          <nav className="flex items-center gap-6">
            <Link 
              to="/guider" 
              className="flex items-center gap-2 bg-white/90 backdrop-blur-sm text-slate-700 hover:text-slate-900 hover:bg-white transition-all font-medium px-4 py-2 rounded-full shadow-md border border-slate-200/50"
              data-testid="nav-guides-link"
            >
              <BookOpen className="w-4 h-4" />
              <span>Guider</span>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
